import { enqueueSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import PMBInputNumber from 'components/PMBInputNumber'
import { formatInputNumber } from 'utility/Utils'
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from 'reactstrap'
import { 
  useEditCurrentAmountProjectGoalsMutation,
  useEditCurrentAmountProjectSharedGoalsMutation
} from './projectDashboardListApiSlice'

const ModalEditCurrentAmount = ({ isOpen, toggle, goal, refetch, isShared }) => {
  const [amount, setAmount] = useState('')
  const [editCurrentAmountOwn, { isLoading: isLoadingOwn }] = useEditCurrentAmountProjectGoalsMutation()
  const [editCurrentAmountShared, { isLoading: isLoadingShared }] = useEditCurrentAmountProjectSharedGoalsMutation()
  
  const editCurrentAmount = isShared ? editCurrentAmountShared : editCurrentAmountOwn
  const isLoading = isShared ? isLoadingShared : isLoadingOwn

  useEffect(() => {
    if (isOpen && goal) {
      setAmount(goal.currentAmount || 0)
    }
  }, [isOpen, goal])

  const handleSubmit = async () => {
    try {
      await editCurrentAmount({
        id: goal.id,
        currentAmount: Number(amount),
      }).unwrap()
      enqueueSnackbar('Current amount berhasil diubah', { variant: 'success' })
      refetch()
      toggle()
    } catch (error) {
      enqueueSnackbar(
        error?.data?.meta?.message ||
          error?.data?.message ||
          'Terjadi kesalahan saat mengubah data',
        { variant: 'error' },
      )
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      data-testid="project-dashboard-modal-edit-current-amount"
    >
      <ModalHeader toggle={toggle}>Ubah Current Amount</ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <label className="fw-semibold mb-1 d-block">Barang / Target</label>
          <div className="text-muted">{goal?.nameItem || '-'}</div>
        </div>
        <div>
          <label className="fw-semibold mb-1 d-block">Current Amount</label>
          <PMBInputNumber
            disabled={isLoading}
            onFocus={(e) => e.target.select()}
            value={formatInputNumber(amount)}
            onChange={(e) => {
              const value = e.target.value
              const replaceValue = value.replace(/[^\d,]/g, '')
              const [integerPart, decimalPart] = replaceValue.split(',')
              const formattedInteger = integerPart.replace(
                /\B(?=(\d{3})+(?!\d))/g,
                '.',
              )
              const formattedValue = decimalPart
                ? `${formattedInteger},${decimalPart}`
                : formattedInteger
              let numericValue =
                parseFloat(
                  formattedValue.replace(/\./g, '').replace(',', '.'),
                ) || null

              setAmount(numericValue !== null ? numericValue.toString() : '')
            }}
            placeholder="0"
            prefix={
              goal?.unit
                ? goal.unit.charAt(0).toUpperCase() + goal.unit.slice(1)
                : ''
            }
            isLastPrefix={true}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          className="btn-cancel"
          outline
          onClick={toggle}
          disabled={isLoading}
          data-testid="project-dashboard-modal-edit-cancel-button"
        >
          Batal
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={isLoading}
          data-testid="project-dashboard-modal-edit-submit-button"
        >
          {isLoading ? <Spinner size="sm" /> : 'Simpan'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalEditCurrentAmount
